import * as React from 'react';

import { assertUnreachable } from '../../../../util/assertUnreachable';

const initialDeleteConfirmationState: DeleteQuizConfirmationState = {
  isOpen: false,
  deleteAction: null,
};
type DeleteConfirmationAction =
  | {
      type: 'open';
      payload: { deleteAction: () => void };
    }
  | { type: 'close' };

interface DeleteConfirmationClosed {
  isOpen: false;
  deleteAction: null;
}

interface DeleteConfirmationOpen {
  isOpen: true;
  deleteAction: () => void;
}

type DeleteQuizConfirmationState =
  | DeleteConfirmationOpen
  | DeleteConfirmationClosed;

function deleteQuizConfirmationReducer(
  state: DeleteQuizConfirmationState,
  action: DeleteConfirmationAction
): DeleteQuizConfirmationState {
  switch (action.type) {
    case 'close': {
      return { isOpen: false, deleteAction: null };
    }
    case 'open': {
      const { deleteAction } = action.payload;
      return { isOpen: true, deleteAction: deleteAction };
    }
    default:
      assertUnreachable(action);
  }
}

export function useDeleteQuizConfirmation() {
  return React.useReducer(
    deleteQuizConfirmationReducer,
    initialDeleteConfirmationState
  );
}
